import getParentIdWorkoutUtil from '../../../modules/workout/model/utils/get-parent-id'
import getDateAgendaUiSelect from '../../agenda-ui/selectors/get-date'
import { DAY_KEY, DAYS_DOMAIN, DAYS_PATH } from '../../day'
import { MESSAGE_KEY } from '../../message'
import { POST_CLASS_NAME, POST_KEY } from '../../post/model/constants'
import POSTS_PATH from '../../posts/constants/path'
import { REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT } from '../../redux/constants/key'
import getReduxSelector from '../../redux/selectors/get'
import getByIdReduxSelector from '../../redux/selectors/get-by-id'
import getCurrentReduxSelector from '../../redux/selectors/get-current'
import { getDomainListDataByDatePeriodReduxSelector } from '../../redux/selectors/get-domain-list-by-date-period'
import { getIdReduxUtil } from '../../redux/utils/get-id'
import getInstancesFromMapReduxUtil from '../../redux/utils/get-instances-from-map'
import getStatusReduxUtil from '../../redux/utils/get-status'
import { getValueReduxUtil } from '../../redux/utils/get-value'
import isLoadingReduxUtil from '../../redux/utils/is-loading'
import isSavingReduxUtil from '../../redux/utils/is-saving'
import isTemporaryId from '../../redux/utils/is-temporary-id'
import { WORKOUT_CLASS_NAME } from '../../workout'
import WORKOUTS_DOMAIN from '../../workout/redux/constants/domain'
import WORKOUTS_PATH from '../../workout/redux/constants/path'
import { createSelector } from 'reselect'

export const getCurrentDaysSelect = getCurrentReduxSelector(
  DAYS_PATH.DATA,
  DAYS_PATH.CURRENT
)

export function getByIdDaysSelector (id) {
  return getByIdReduxSelector(DAYS_PATH.DATA, id)
}

export const getCurrentIdDaysSelect = createSelector(
  getCurrentDaysSelect,
  instance => {
    return getIdReduxUtil(instance)
  }
)

export const getCurrentValueDaysSelect = createSelector(
  getCurrentDaysSelect,
  instance => {
    return getValueReduxUtil(instance, MESSAGE_KEY.VALUE)
  }
)
export const getCurrentReduxStatusDaysSelect = createSelector(
  getCurrentDaysSelect,
  instance => {
    return getStatusReduxUtil(instance)
  }
)

export const isCurrentPendingDaysSelect = createSelector(
  getCurrentDaysSelect,
  (instance) => {
    return (
      isLoadingReduxUtil(instance) || isSavingReduxUtil(instance)
    )
  }
)

export const getAgendaWorkoutIdsSelect = state => {
  const date = getDateAgendaUiSelect(state)
  return getDomainListDataByDatePeriodReduxSelector({
    domainPath: WORKOUTS_DOMAIN,
    datePeriodUnit: REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.DAY,
    date
  })(state)
}

export const getAgendaDaySelect = state => {
  const date = getDateAgendaUiSelect(state)
  const dayIds = getDomainListDataByDatePeriodReduxSelector({
    domainPath: DAYS_DOMAIN,
    datePeriodUnit: REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT.DAY,
    date
  })(state)
  const dayId = dayIds.filter(id => !isTemporaryId(id))[0]
  return getByIdDaysSelector(dayId)(state)
}

export const getChallengeWorkoutIdsSelect = state => {
  const day = getAgendaDaySelect(state)

  const workoutPointers = getValueReduxUtil(day, DAY_KEY.WORKOUTS)
  let workoutIds
  if (workoutPointers?.length) {
    workoutIds = workoutPointers.map(getIdReduxUtil)
  }

  if (workoutIds?.length) {
    return workoutIds
  }

  return []
}

export const getChallengeQuoteIdsSelect = state => {
  const day = getAgendaDaySelect(state)
  const quotePointers = getValueReduxUtil(day, DAY_KEY.QUOTES)
  let quoteIds
  if (quotePointers?.length) {
    quoteIds = quotePointers.map(getIdReduxUtil)
  }
  if (quoteIds?.length) {
    return quoteIds
  }
  return []
}

export const getChallengeArticleIdsSelect = state => {
  const day = getAgendaDaySelect(state)
  const articlePointers = getValueReduxUtil(day, DAY_KEY.ARTICLES)
  let articleIds
  if (articlePointers?.length) {
    articleIds = articlePointers.map(getIdReduxUtil)
  }
  if (articleIds?.length) {
    return articleIds
  }
  return []
}

export const getAgendaItemsDataSelect = state => {
  const workoutIds = getAgendaWorkoutIdsSelect(state)
  const workouts = getInstancesFromMapReduxUtil(getReduxSelector(WORKOUTS_PATH.DATA)(
    state), workoutIds)

  const data = []

  const quoteIds = getChallengeQuoteIdsSelect(state)
  const quotes = getInstancesFromMapReduxUtil(getReduxSelector(POSTS_PATH.DATA)(
    state), quoteIds)
  quotes.forEach(quote => {
    data.push({
      className: POST_CLASS_NAME,
      type: getValueReduxUtil(quote, POST_KEY.TYPE),
      id: getIdReduxUtil(quote),
      shouldSkip: true
    })
  })

  const articleIds = getChallengeArticleIdsSelect(state)
  const articles = getInstancesFromMapReduxUtil(getReduxSelector(POSTS_PATH.DATA)(
    state), articleIds)
  articles.forEach(article => {
    data.push({
      className: POST_CLASS_NAME,
      type: getValueReduxUtil(article, POST_KEY.TYPE),
      id: getIdReduxUtil(article),
      shouldSkip: true
    })
  })

  const challengeParentIdMap = {}
  workouts.forEach(workout => {
    challengeParentIdMap[getParentIdWorkoutUtil(workout)] = true
    data.push({
      className: WORKOUT_CLASS_NAME,
      id: getIdReduxUtil(workout)
    })
  })

  const challengeWorkoutIds = getChallengeWorkoutIdsSelect(state)
  challengeWorkoutIds.forEach((workoutId) => {
    if (challengeParentIdMap[workoutId]) {
      data.push({
        className: WORKOUT_CLASS_NAME,
        id: workoutId,
        shouldSkip: true,
        hasCompletedChallenge: true
      })
      return
    }
    return data.push({
      className: WORKOUT_CLASS_NAME,
      id: workoutId,
      isChallenge: true
    })
  })

  return data
}

export const hasCompletedChallengeWorkoutAgendaItemsDataSelect = createSelector(
  getAgendaItemsDataSelect,
  items => !!items.find(item => item.hasCompletedChallenge)
)
